import { render, staticRenderFns } from "./HolUeb.vue?vue&type=template&id=07490dbc&scoped=true&"
import script from "./HolUeb.vue?vue&type=script&lang=js&"
export * from "./HolUeb.vue?vue&type=script&lang=js&"
import style0 from "./HolUeb.vue?vue&type=style&index=0&id=07490dbc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07490dbc",
  null
  
)

export default component.exports